var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#0A66C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.715 217.685H213.985C216.194 217.685 217.985 215.895 217.985 213.686L218 151.844C218 119.521 211.035 94.6755 173.262 94.6755C158.903 94.1423 145.362 101.544 138.055 113.904C137.997 114.002 137.893 114.062 137.779 114.062C137.603 114.062 137.46 113.919 137.46 113.743V101.66C137.46 99.4511 135.67 97.6602 133.46 97.6602H105.683C103.474 97.6602 101.683 99.4511 101.683 101.66V213.68C101.683 215.89 103.474 217.68 105.683 217.68H134.951C137.16 217.68 138.951 215.89 138.951 213.68V158.307C138.951 142.65 141.921 127.487 161.332 127.487C180.467 127.487 180.715 145.403 180.715 159.321V213.685C180.715 215.894 182.506 217.685 184.715 217.685Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59.6275C38 71.4921 47.7675 81.2539 59.6321 81.2539C71.4944 81.2528 81.2551 71.4853 81.2551 59.623C81.2528 47.7607 71.491 38 59.6275 38C47.763 38 38 47.763 38 59.6275Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9588 217.685H74.2659C76.4751 217.685 78.2659 215.894 78.2659 213.685V101.66C78.2659 99.4511 76.4751 97.6602 74.2659 97.6602H44.9588C42.7497 97.6602 40.9588 99.4511 40.9588 101.66V213.685C40.9588 215.894 42.7497 217.685 44.9588 217.685Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.d4c434360abe218c6dd4c0841fcde43b.svg";
export { ForwardRef as ReactComponent };